export default __webpack_public_path__ + "static/media/blue_earth.4e4f7f40.png";